import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the productDetailsPage state domain
 */

const selectProductDetailsPageDomain = (state: ApplicationRootState) => {
  return state ? state.productDetailsPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by ProductDetailsPage
 */

const selectProductDetailsPage = () =>
  createSelector(selectProductDetailsPageDomain, substate => {
    return substate;
  });

const selectProduct = () =>
  createSelector(selectProductDetailsPageDomain, substate => {
    return substate.product;
  });

export default selectProductDetailsPage;
export { selectProductDetailsPageDomain, selectProduct };
